import Vue from "vue";
const vm = Vue.prototype;
import $i18n from "../i18n";

import checkApp from "../service/check-application.js";
import fileTypes from "../service/file-types.js";
import toDate from "../service/to-date.js";

export const state = () => ({
  application: checkApp(),
  disabilitys: [],
  countrys: [],
  regions: [],
  citys: [],
  schoolRegions: [],
  schoolCitys: [],
  educationFacultys: [],
  educationTypes: [],
  educationLanguages: [],
  schoolTypes: [],
  certificates: [],
  payments: [],
  payment: {},
});

export const mutations = {
  INIT_APPLICATION(state, payload) {
    state.application = payload;
  },

  SET_APPLICATION(state, payload) {
    state.application = payload || checkApp();
  },

  INIT_DISABILITYS(state, payload) {
    state.disabilitys = vm.$toArray(payload);
  },

  INIT_COUNTRYS(state, payload) {
    state.countrys = vm.$toArray(payload);
    state.regions = [];
    state.citys = [];
  },

  INIT_REGIONS(state, payload) {
    state.regions = vm.$toArray(payload);
    state.citys = [];
  },

  INIT_CITYS(state, payload) {
    state.citys = vm.$toArray(payload);
  },

  INIT_SCHOOL_REGIONS(state, payload) {
    state.schoolRegions = vm.$toArray(payload);
  },

  INIT_SCHOOL_CITYS(state, payload) {
    state.schoolCitys = vm.$toArray(payload);
  },

  INIT_EDUCATION_FACULTYS(state, payload) {
    state.educationFacultys = vm.$toArray(payload);
    state.educationTypes = [];
  },

  INIT_EDUCATION_TYPES(state, payload) {
    state.educationTypes = vm.$toArray(payload);
    state.EducationLanguages = [];
  },

  INIT_EDUCATION_LANGUAGES(state, payload) {
    state.educationLanguages = vm.$toArray(payload);
  },

  INIT_SCHOOL_TYPES(state, payload) {
    state.schoolTypes = vm.$toArray(payload);
  },

  INIT_CERTIFICATES(state, payload) {
    state.certificates = vm.$toArray(payload);
  },

  SET_APPLICATION_PHOTO(state, payload) {
    const obj = { ...state.application };
    if (payload) {
      const { param, id } = payload;

      obj[param] = `/api/v1/admin/contract2026/file/${id}`;
    }

    state.application = obj;
  },

  SET_PAYMENTS(state, payload) {
    state.payments = vm.$toArray(payload);
  },

  SET_PAYMENT_BY_ID(state, payload) {
    state.payment = payload || {};
  },

};

export const actions = {
  async INIT_APPLICATION({ dispatch, commit }, application) {
    const app = application;
    commit("INIT_APPLICATION", app);
    await dispatch("INIT_DISABILITYS");
    await dispatch("INIT_COUNTRYS");
    await dispatch("INIT_SCHOOL_REGIONS");
    await dispatch("INIT_SCHOOL_TYPES");
    await dispatch("INIT_CERTIFICATES");
    await dispatch("INIT_REGIONS", { countryId: app.country.id });
    await dispatch("INIT_CITYS", { regionId: app.region.id });
    await dispatch("INIT_SCHOOL_CITYS", { regionId: app.schoolRegion.id });
    await dispatch("INIT_EDUCATION_FACULTYS");
    await dispatch("INIT_EDUCATION_TYPES", { id: app.educationFaculty.id });
    await dispatch("INIT_EDUCATION_LANGUAGES", {
      typeId: app.educationType.id,
      facultyId: app.educationFaculty.id,
    });

    return;
  },

  async INIT_PAYMENTS({ commit }, { contractId }) {
    let totalItemsCount = 0;
    const data = await vm.$axios.$get(
      `admin/contract2026/payments/list/${contractId}`
    );
    if (data) {
      commit("SET_PAYMENTS", data.content);
      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async PAYMENT_BY_ID({ commit }, { id }) {
    let status = false;

    try {
      const data = await vm.$axios.$get(
        `admin/contract2026/payments/get/${id}`
      );
      if (Array.isArray(data)) {
        commit("SET_PAYMENT_BY_ID", data);

        status = true;
      }
    } catch (error) {
      //
    }

    return status;
  },

  async ADD_PAYMENT(ctx, payment) {
    let status = false;
    const params = { ...payment };
    params.paymentDate = toDate(params.paymentDate);
    const url = "admin/contract2026/payment/update";
    const method = payment.id ? "$post" : "$put";

    status = await vm.$axios[method](url, params);

    return status;
  },

  async DELETE_PAYMENT(ctx, paymentId) {
    try {
      await vm.$axios.$delete(`admin/contract2026/payment/${paymentId}`);
      return true;
    } catch {
      return false;
    }
  },

  SET_APPLICATION({ commit }, payload) {
    commit("SET_APPLICATION", payload);
  },

  async SAVE_APPLICATION_PAYMENT({ commit, dispatch }, application) {
    const params = { ...application };
    params.birthDate = toDate(params.birthDate);
    params.passedDate = toDate(params.passedDate);
    params.paymentDate = toDate(params.paymentDate);

    const url = "admin/contract2026/payment";
    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      application.currentPayment != 0;
      commit("SET_APPLICATION", application);

      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async SAVE_APPLICATION_PROMOTION(ctx, promotion) {
    let status = false;
    const params = { ...promotion };
    const url = "admin/contract2026/promotion";

    status = await vm.$axios.$post(url, params);
    return status;
  },

  async SAVE_APPLICATION({ commit, dispatch }, application) {
    const params = { ...application };
    params.birthDate = toDate(params.birthDate);
    params.passedDate = toDate(params.passedDate);
    params.paymentDate = toDate(params.paymentDate);
    const url = "admin/contract2026/edit";
    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      application.currentPayment != 0;
      commit("SET_APPLICATION", application);

      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async SAVE_APPLICATION_NEW_CONTRACT({ commit, dispatch }, application) {
    const params = { ...application };
    params.birthDate = toDate(params.birthDate);
    params.passedDate = toDate(params.passedDate);
    params.paymentDate = toDate(params.paymentDate);
    const url = "admin/contract2026/add/student/data";
    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      application.currentPayment != 0;
      commit("SET_APPLICATION", application);

      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async GET_SCIENCES_BY_LANG(ctx, { langId }) {
    const url = `admin/education/${langId}/science-complex/all`;
    const data = await vm.$axios.$get(url);
    return vm.$toArray(data);
  },

  async INIT_DISABILITYS({ commit }) {
    const payload = await vm.$axios.$get("admin/disability/all"); //--

    commit("INIT_DISABILITYS", payload);
  },

  async INIT_SCHOOL_TYPES({ commit }) {
    const payload = await vm.$axios.$get("admin/school-type/all");
    commit("INIT_SCHOOL_TYPES", payload);
  },

  async INIT_CERTIFICATES({ commit }) {
    const url = "admin/foreign-language-proficiency/all"; //--
    const payload = await vm.$axios.$get(url);
    commit("INIT_CERTIFICATES", payload);
  },

  async INIT_COUNTRYS({ commit }) {
    const payload = await vm.$axios.$get("admin/country/all");
    commit("INIT_COUNTRYS", payload);
  },

  async INIT_REGIONS({ commit }, { countryId }) {
    commit("INIT_REGIONS", []);
    if (countryId) {
      const url = `admin/region/all/${countryId}`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_REGIONS", payload);
    }
  },

  async INIT_CITYS({ commit }, { regionId }) {
    commit("INIT_CITYS", []);
    if (regionId) {
      const url = `admin/city/all/${regionId}`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_CITYS", payload);
    }
  },

  async INIT_SCHOOL_REGIONS({ commit }) {
    commit("INIT_SCHOOL_REGIONS", []);

    const url = `admin/region/all/${1}`;
    const payload = await vm.$axios.$get(url);
    commit("INIT_SCHOOL_REGIONS", payload);
  },

  async INIT_SCHOOL_CITYS({ commit }, { regionId }) {
    commit("INIT_SCHOOL_CITYS", []);

    if (regionId) {
      const url = `admin/city/all/${regionId}`;

      const payload = await vm.$axios.$get(url);
      commit("INIT_SCHOOL_CITYS", payload);
    }
  },

  async INIT_EDUCATION_FACULTYS({ commit }) {
    commit("INIT_EDUCATION_FACULTYS", []);

    const url = `admin/education/faculty/all`;
    const payload = await vm.$axios.$get(url);
    commit("INIT_EDUCATION_FACULTYS", payload);
  },

  async INIT_EDUCATION_TYPES({ commit }, { id }) {
    commit("INIT_EDUCATION_TYPES", []);

    if (id) {
      const url = `admin/education/${id}/type/all`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_EDUCATION_TYPES", payload);
    }
  },

  async INIT_EDUCATION_LANGUAGES({ commit }, { typeId, facultyId }) {
    commit("INIT_EDUCATION_LANGUAGES", []);

    if (typeId && facultyId) {
      const url = `admin/education/${facultyId}/${typeId}/language/all`;
      const payload = await vm.$axios.$get(url);

      commit("INIT_EDUCATION_LANGUAGES", payload);
    }
  },

  async UPLOAD_FILE({ commit }, { file, param, applicationId }) {
    const fileType = fileTypes[param];

    if (fileType) {
      const form = new FormData();
      form.append("file", file);

      const url = `admin/contract2026/file/${fileType}/${applicationId}`;
      const data = await vm.$axios.$post(url, form);

      if (data) {
        commit("SET_APPLICATION_PHOTO", { id: data, param });
      }
    }
  },

  async GET_FILE_API(ctx, { url }) {
    if (url) {
      return await vm.$axios.$getImage(url);
    } else return null;
  },

  async DELETE_FILE_API({ commit }, { param, applicationId }) {
    const fileType = fileTypes[param];

    if (fileType) {
      const url = `admin/2026file/${fileType}/${applicationId}`;
      const status = await vm.$axios.$delete(url);

      if (status != null) {
        commit("SET_APPLICATION_PHOTO", { url: null, param });
      }
    }
  },

  async ADD_GROUP_NUMBER(ctx, group) {
    let status = false;
    const contractId = group.id;
    const groupName = group.name;
    const url = `/admin/contract2026/group/${contractId}/${groupName}`;
    const method = "$put";

    status = await vm.$axios[method](url);
    return status;

    /* if (status) {
          dispatch(
            "SET_SNACKBAR",
            {
              text: $i18n.t("Successfully sent!"),
              color: "success",
            },
            { root: true }
          );
        }*/
  },

};

export const getters = {
  GET_APPLICATION: (state) => state.application,
  GET_DISABILITYS: (state) => state.disabilitys,
  GET_COUNTRYS: (state) => state.countrys,
  GET_REGIONS: (state) => state.regions,
  GET_CITYS: (state) => state.citys,
  GET_SCHOOL_REGIONS: (state) => state.schoolRegions,
  GET_SCHOOL_CITYS: (state) => state.schoolCitys,
  GET_EDUCATION_FACULTYS: (state) => state.educationFacultys,
  GET_EDUCATION_TYPES: (state) => state.educationTypes,
  GET_EDUCATION_LANGUAGES: (state) => state.educationLanguages,
  GET_SCHOOL_TYPES: (state) => state.schoolTypes,
  GET_CERTIFICATES: (state) => state.certificates,
  GET_PAYMENTS: (state) => state.payments,
  GET_PAYMENT_BY_ID: (state) => state.payment,
};
